module.exports = __webpack_public_path__ + "img/make-brushes-1_cn.f978ec1.jpg";